import "./style.css";
import Modal from "react-bootstrap/Modal";
// import { apiCity, apiState } from "../../../api/stateAndCity";
// import { useEffect, useState } from "react";

function CompanyViews(props) {
  // const [stateValue,setStateValue] = useState([]);
  // const [city,setCity] = useState([]);

  // async function getStateAndCity() {
  //   await apiState().then(result => setStateValue(result.data.data.list));
  //   await apiCity().then(result => setCity(result?.data?.data.list));
  // }

  // useEffect(function () {
  //   getStateAndCity();
  // }, []);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "12rem", height: "4px" }} id="modalhead">
          View Customer
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <div className="row gy-3">
          <div className="col-md-6">
            <label htmlFor="buyer_contact">Customer Name</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="comp_address"
              value={props.id?.customer_name}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="cust_address">Customer Mobile</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="cust_address"
              value={props.id?.customer_mobile}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="cust_address">Customer Address</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="cust_address"
              value={props.id?.cust_address}
            />
          </div>
          {/* <div className="col-md-6">
            <label htmlFor="credit_days">State</label>
            <select
              type="text"
              className="form-control"
              id="buyer_type"
              disabled
              value={props.id?.buyer_type}
              >
              <option value="" hidden>
                N/A
              </option>
              {stateValue?.map((list) => (
                <>
                  <option value={list.state_id} selected={list.state_id === props.id?.cust_state_id}>{list.name}</option>
                </>
              ))}
            </select>
          </div>
          <div className="col-md-6">
            <label htmlFor="credit_amt">City</label>
            <select
              type="text"
              className="form-control"
              id="buyer_type"
              disabled
              value={props.id?.buyer_type}
              >
              <option value="" hidden>
                N/A
              </option>
              {city?.map((list) => (
                <>
                  <option value={list.city_id} selected={list.city_id === props.id.cust_city_id}>{list.city}</option>
                </>
              ))}
            </select>
          </div>
          <div className="col-md-6">
            <label htmlFor="comp_pincode">Pincode</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="cust_pincode"
              value={props.id?.cust_pincode}
            />
          </div> */}
          <div className="col-12 mt-4">
            <button
              className="branchModalCancel"
              onClick={props.hide}
              to="/branch"
              style={{
                height: "33px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                float: "right",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanyViews;
